'use client';

import { useEffect, useState } from 'react';

export type ScrollDirection = 'down' | 'up';

export function useScrollDirection(): ScrollDirection | null {
	const [scrollDirection, setScrollDirection] = useState<ScrollDirection | null>(null);

	useEffect(() => {
		let lastScrollY = window.pageYOffset;

		const updateScrollDirection = () => {
			const scrollY = window.pageYOffset;
			const direction: ScrollDirection = scrollY > lastScrollY ? 'down' : 'up';
			if (
				direction !== scrollDirection &&
				(scrollY - lastScrollY > 10 || scrollY - lastScrollY < -10)
			) {
				setScrollDirection(direction);
			}
			lastScrollY = scrollY > 0 ? scrollY : 0;
		};
		window.addEventListener('scroll', updateScrollDirection);
		return () => {
			window.removeEventListener('scroll', updateScrollDirection);
		};
	}, [scrollDirection]);

	return scrollDirection;
}
